/**
 * Dev-only escape hatch for the work-focus enrolment gate and session guard.
 *
 * Ignored in production builds even if the variable is set — `import.meta.env.DEV` is false
 * after `vite build`, so this cannot disable monitoring in a shipped bundle.
 */
export function isWorkFocusDisabledInDev(): boolean {
  if (!import.meta.env.DEV) return false;
  return (
    import.meta.env.VITE_WORK_FOCUS_DISABLED === 'true' ||
    import.meta.env.VITE_WORK_FOCUS_DISABLED === '1'
  );
}
